import { create } from 'zustand';

export type ConnectionStatus =
  | 'initial'
  | 'connected'
  | 'connecting'
  | 'disconnected';

interface ConnectionStore {
  status: ConnectionStatus;
  setStatus: (status: ConnectionStatus) => void;
}

export const useConnectionStore = create<ConnectionStore>()((set) => ({
  status: 'initial',
  setStatus: (status) => set({ status }),
}));
